import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [appData, setAppData] = useState({});
  const [userAccessData, setUserAccessData] = useState({});
  const [announcements, setAnnouncements] = useState([]);
  const [areAnnouncementsLoading, setAreAnnouncementsLoading] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [updateUserData, setUpdateUserData] = useState(true);
  const [pageTitle, setPageTitle] = useState("");
  const [pageUserID, setPageUserID] = useState(null);


  return (
    <AppContext.Provider value={
      {
        pageTitle, setPageTitle,
        updateUserData, setUpdateUserData,
        loggedInUserData, setLoggedInUserData,
        isLoggedIn, setIsLoggedIn,
        appData, setAppData,
        userAccessData, setUserAccessData,
        announcements, setAnnouncements,
        areAnnouncementsLoading, setAreAnnouncementsLoading,
        pageUserID, setPageUserID
      }
    }>
      {children}
    </AppContext.Provider>
  );
};
